export const withoutToolNames = (text: string, toolNames: readonly string[]): string => {
  if (toolNames.length === 0) return text;
  const name = `\`?(?:${[...toolNames]
    .sort((a, b) => b.length - a.length)
    .map(escapeRegExp)
    .join("|")})\`?`;
  const end = "(?=[\\s.,;:!?)]|$)";
  return text
    .replace(new RegExp(`[ \\t]*\\([ \\t]*${name}[ \\t]*\\)`, "g"), "")
    .replace(new RegExp(`[ \\t]+(?:${INSTRUMENT_WORDS})[ \\t]+(?:verktøyet[ \\t]+)?${name}${end}`, "g"), "");
};

const INSTRUMENT_WORDS = ["ved hjelp av", "med", "via", "gjennom"].join("|");

const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
